import * as React from "react";
import { Grid, Button } from "semantic-ui-react";
import * as moment from "moment";

import { MedicalTypeId } from "@teamprevent/common/healthSurveillance";

import { SetRecallModel } from "../models";

import { RecallCaseDetails } from "./RecallCaseDetails";

interface Props {
    recalls: SetRecallModel[];
    onRecallsChanged: (recalls: SetRecallModel[]) => void;
    hideRecallYearsAndWeeks?: boolean;
}

const RecallForm: React.FunctionComponent<Props> = (props) => {
    const [editable, setEditable] = React.useState(false);

    const onClickEdit = () => setEditable(!editable);

    const onDateChanged = (index: number) => (date: moment.Moment) => {
        props.onRecallsChanged(props.recalls.map((r, i) =>
            i === index ? { ...r, recallDate: date } : r));
    };

    const onMedicalDropped = (index: number) => (medicalTypeId: MedicalTypeId) =>
        props.onRecallsChanged(props.recalls.map((r, i) => {
            let medicalTypes: MedicalTypeId[];
            if (i === index) {
                medicalTypes = r.medicalTypes.includes(medicalTypeId) ? r.medicalTypes : [...r.medicalTypes, medicalTypeId];
            } else {
                medicalTypes = r.medicalTypes.filter(m => m !== medicalTypeId);
            }
            return { ...r, medicalTypes };
        }));

    return (
        <Grid>
            <Grid.Row>
                <Grid.Column width="16" textAlign="right">
                    {<Button content={editable ? "Read-Only" : "Edit"} floated="right" onClick={onClickEdit} />}
                </Grid.Column>
            </Grid.Row>
            {props.recalls.map((recall, index) =>
                (<RecallCaseDetails
                    key={index}
                    caseId={recall.ohCaseNumber ? `Health Surveillance Case ${recall.ohCaseNumber}` : `New Health Surveillance Case ${index + 1}`}
                    recallYear={recall.recallYears}
                    recallWeek={recall.recallWeeks}
                    recallDate={recall.recallDate}
                    medicalTypes={recall.medicalTypes}
                    editable={editable}
                    onDateChanged={onDateChanged(index)}
                    onMedicalDropped={onMedicalDropped(index)}
                    hideRecallYearsAndWeeks={props.hideRecallYearsAndWeeks}
                    inflight={recall.inflight}
                />))}
        </Grid>
    );
};

export { RecallForm };
